import { ProfileAbout } from '@components/ProfileAbout';

import { useProfileAboutQuery } from './graphql.v3.generated';

type ProfileAboutContainerProps = {
  username: string
  className?: string
};

export const ProfileAboutContainer: React.FC<ProfileAboutContainerProps> = ({
  username,
  className,
}) => {
  const { data, loading } = useProfileAboutQuery({
    variables: { username },
    context: { batch: true },
  });

  if (loading) {
    return null;
  }

  return (
    <ProfileAbout
      className={className}
      text={data?.user?.about}
    />
  );
};
